import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {environment} from '@env/environment';
import * as moment from 'moment';
import {CookieService} from 'ngx-cookie';
import { AuthenticationService, UserService } from '../_services';
import { UserContext } from '../_context/user.context';
import Swal from 'sweetalert2';
import { Alert, AlertTypeEnum } from '../shared/Helpers/Alert';

@Component({
  moduleId: module.id,
  templateUrl: './saml-login.html',
  selector: 'saml-login'
})
export class SamlLoginComponent implements OnInit {
  private Key: any
  public loading: boolean = false;
  public isUserAuthenticated: boolean = true;
  public logInForm: any = {};
  public passwordMode: boolean = true;
  public type: string = 'password';

  constructor(
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private userService: UserService,
    private cookieService: CookieService
  ) {
  }

  ngOnInit(): void {
    this.Key = this.route.snapshot.queryParams['token'];
    this.CheckUserAuthenticated();
  }

  private CheckUserAuthenticated(): void {
    const currentUser = localStorage.getItem('currentUser');
    const ableToken = localStorage.getItem('ableToken');
    if (currentUser || ableToken) {
      this.isUserAuthenticated = true;
      this.SamlRequest();
    } else {
      this.isUserAuthenticated = false;
    }
  }

  private SamlRequest(): void {
    this.authenticationService.samlRequest(this.Key).subscribe((data) => {
      var markup: any = data.body;
      var wnd: any = window.open("about:blank", "");

      if (!wnd || wnd.closed || typeof wnd == 'undefined' || typeof wnd.closed == 'undefined') {
        let msg: any = ' <p> Your browser is blocking pop ups, please allow them and click here to be redirected</p>';
        Swal.fire({
          title: 'Allow popup',
          html: msg,
          showCancelButton: false,
          showConfirmButton: true,
          confirmButtonText: 'Click here',
          customClass: 'sweetalert-lg',
          width: '500px'
        }).then((result) => {
          var wnd: any = window.open("about:blank", "");
          wnd.document.write(markup);
          wnd.document.close();
          var win: any = window.open("about:blank", "_self");
          win.close();
          window.close();
        });
      } else {
        wnd.document.write(markup);
        wnd.document.close();
        var win: any = window.open("about:blank", "_self");
        win.close();
        window.close();
      }
    });
  }

  public login() {
    this.loading = true;
    this.authenticationService.login(this.logInForm.username, this.logInForm.password).subscribe({
      next: (data) => {
        const user = data.body;
        if (user && user.token) {
          let idamUrl: string = environment.identityCookieUrl;
          idamUrl = idamUrl.substr( idamUrl.indexOf('//') + 2);
          idamUrl = idamUrl.substr(0, idamUrl.indexOf(':'));
          if (idamUrl.indexOf('.') > -1) { idamUrl = idamUrl.substr( idamUrl.indexOf('.')); }
          this.cookieService.put('ABLEIDENTITY', data.body.token,{path: '/', expires: moment(new Date()).add(30, 'm').toDate(), domain: idamUrl});
          localStorage.setItem('currentUser', JSON.stringify(user));
        }

        this.getPeopleData();
      },
      error: (err) => {
        if (err.status === 401) {
          Alert.basicNotification(AlertTypeEnum.Error, "Login error", "Your credentials were not correct. Please check your username and password and try again.");
          this.loading = false;
        } else if (err.status === 404 || err.status === 0) {
          Alert.basicNotification(AlertTypeEnum.Error, "Login error", "You appear to be offline. Please check your connection and try again.");
          this.loading = false;
        } else {
          Alert.basicNotification(AlertTypeEnum.Error, "Login error", "An error occurred. Please try again later.");
          this.loading = false;
        }
      }
    });
  }

  private getPeopleData() {
    const currentUser: UserContext = new UserContext();
    if (currentUser.isAuthenticated) {
      this.userService.getPeopleById(currentUser.personID).subscribe((data) => {
        const peopleData = data.body;
        this.userService.getHomeUser(peopleData.id).subscribe((userData) => {
          const user = userData.body;
          const filterUser = user.filter(item => item.isHomeUser == true);
          this.contextualizeToken(filterUser[0].organisation.id);
        });
      })
    }
  }

  private contextualizeToken(organisationId: any) {
    this.userService.contextualizeToken(organisationId).subscribe((data) => {
      const user = data.body;
      localStorage.setItem('currentUser', JSON.stringify(user));
      this.SamlRequest();
    })
  }

  passwordModeOff() {
    this.passwordMode = false;
    this.type = 'text';
  }

  passwordModeOn() {
    this.passwordMode = true;
    this.type = 'password';
  }
}
